import Image from 'next/image';
import NewTabDarkCharcoal from './new_tab_dark_charcoal.svg?url';
import NewTabWhite from './new_tab_white.svg?url';
import type { SvgImageProps } from '../types';

export const NewTabDarkCharcoalImage: React.FC<SvgImageProps> = ({
  alt,
  ...props
}) => <Image src={NewTabDarkCharcoal} alt={alt} {...props} />;

export const NewTabWhiteImage: React.FC<SvgImageProps> = ({
  alt,
  ...props
}) => <Image src={NewTabWhite} alt={alt} {...props} />;
